import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class LogGrid extends BaseComponent {
	
	static get properties() {
		return {	
			nodeId: {type: String}
		};
	}
	
	constructor() {
		super();
		
		var logGrid = this;
		setTimeout(function(){
			logGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var logGrid = this;
		
		var loggingStatus = ElementUtil.create({
			tag: 'div',
			'class': 'status-dbLog-bar',			
			children: [
				{
					tag: 'style',
					innerHTML: `
						.status-dbLog-bar {
							text-align: center;
							font-size: 20px;
							padding: 5px;
							background-color: lightgrey;
						}
						.status-dbLog-bar-running {
							background-color: #0cff0c;
						}
						.status-dbLog-bar-standby {
							background-color: darkgrey;
							color: white;
						}
					`
				},
				{
					tag: 'span',
					itemid: 'text',
					innerHTML: 'Checking...'
				}
			]
		});
		
		var actionUpdateStatus = function() {
			
			loggingStatus.classList.remove('status-dbLog-bar-running');
			loggingStatus.classList.remove('status-dbLog-bar-standby');
			
			Service.getNodeService().getDBStatus(logGrid.nodeId).then(function(status) {
				var text = '';
				if (status.data) {
					loggingStatus.classList.remove('status-dbLog-bar-standby');
					loggingStatus.classList.add('status-dbLog-bar-running');
					logGrid.dbLoggingOn = true;
					text = "DB Logging is ON";
				} else {
					loggingStatus.classList.remove('status-dbLog-bar-running');
					loggingStatus.classList.add('status-dbLog-bar-standby');
					logGrid.dbLoggingOn = false;
					text = "DB Logging is OFF";
				}
				ElementUtil.query(loggingStatus, 'text').innerHTML = text;
			});
			
			
		};
		actionUpdateStatus();
		
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				loggingStatus,
				{
					tag: 'vaadin-button',
					itemid: 'logs',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:download', ' Logs')
					], 
					listeners: {
						click: function() {
							actionViewLogs();
						}
					}
				},
				{
					tag: 'vaadin-text-field',
					itemid: 'filtername',
					'class': 'spacer-toolbar-item',
					'keep-open': true,
					label: 'Filter By Log Name',
					listeners: {
						input: {
							fn: function() {
								filterGrid();
							},
							buffer: 1000
						}
					}
				},
				{
					tag: 'dl-action-button',											
					itemid: 'dbLogs',
					theme: 'contrast primary',
					'class': 'spacer-toolbar-item',
					style: 'float: right; margin-top: 18px;',
					permissions: ['ADMIN_SYSTEM:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:check-square', ' Toggle DB Logging')
					],
					listeners: {
						click: function() {
							actionToggleDBLogs();
						}
					}
				},
				{
					tag: 'dl-action-button',											
					itemid: 'levels',					
					'class': 'spacer-toolbar-item',
					style: 'float: right; margin-top: 18px;',
					permissions: ['ADMIN_SYSTEM:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:slider', ' Set Level')
					],
					listeners: {
						click: function() {
							actionSetLevel(grid.selectedItems[0]);
						}
					}
				}
				
				
			]
		});		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: [				
				{						
					path: 'name',
					header: 'Name',
					width: '12em',
					'flex-grow': '1'
				},
				{						
					path: 'level',
					header: 'Level',
					'text-align': 'center',
					width: '5em'
				},
				{
					path: 'handlers',
					header: 'Handlers',
					width: '9em'										
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {						
						ElementUtil.query(toolbar, 'levels').disabled = false;
					} else {
						ElementUtil.query(toolbar, 'levels').disabled = true;
					}	
				}
			}
		});	
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid
			]
		});		
		logGrid.append(flexLayout);		
		
		logGrid.logs = [];
		var actionRefresh = function() {
			var loadMask = logGrid.showLoading();	
			Service.getNodeService().getLoggers(logGrid.nodeId).then(function(logs){
				loadMask.remove();
				
				logGrid.logs = logs;
				filterGrid();
			});					
			
		};
		actionRefresh();
		
		var filterGrid = function() {
			
			var filter = ElementUtil.query(toolbar, 'filtername').value;			
			var filteredLogs = [];
			if (filter) {
				logGrid.logs.forEach(function(log){
					if (log.name.includes(filter)) {
						filteredLogs.push(log);
					}
				});	
			} else {
				filteredLogs = logGrid.logs.slice(0);
			}			
			
			grid.activeItem = null;
			grid.items = filteredLogs;				
		};
		
		var actionToggleDBLogs = function() {			
			Service.getNodeService().activateDBLogging(logGrid.nodeId, !logGrid.dbLoggingOn).then(function(result){
				actionUpdateStatus();
				actionRefresh();
			});
		};
		
		var actionSetLevel = function(record) {
			
			var levelWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Set Log Level',
				icon: 'lumo:edit',
				width: 450,
				height: 175,
				listeners: {
					ready: function() {						
						levelWin.show();
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [
										{
											tag: 'vaadin-combo-box',
											label: 'Log Level', 
											name: 'level',
											'clear-button-visible': true,
											'item-value-path': 'code',
											'item-label-path': 'description',											
											postinit: function(combo) {
												Service.getApplicationService().getLogLevels().then(function(data){
													combo.items = data;
												});
											}									
										},									
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {

															formPanel.submitForm({
																actualCall: function(data) {
																	return Service.getNodeService().updateLogLevel(logGrid.nodeId, record.name, data);
																},
																success: function(data, responseData) {
																	actionRefresh();
																	levelWin.close();
																	window.DL.MessageUtil.showToast('Success', 'Saved: ' + data.description, {
																		theme: 'success'
																	});	
																}
															});																

														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															levelWin.close();
														}
													}
												}
											]
										}
									]
								}
							]

						});
						levelWin.addToContentElement(formPanel);			

						if (record) {
							//load form
							formPanel.load(record);
						}
						
					}
				}
			});			
			
		};

		var actionViewLogs = function() {
			
			var logWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Log File',
				icon: 'lumo:eye',
				width: .7,
				height: .6,
				listeners: {
					ready: function() {						
						logWin.show();
												
						var logToolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'toolbar',
							theme: 'spacing',
							children: [
								{
									tag: 'vaadin-button',
									itemid: 'logs',
									'class': 'spacer-toolbar-item',
									children:[
										ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
									], 
									listeners: {
										click: function() {
											actionRefreshLogs();
										}
									}
								},								
								{
									tag: 'dl-action-button',											
									itemid: 'download',
									theme: 'contrast primary',
									'class': 'spacer-toolbar-item',
									style: 'float: right;',
									permissions: ['ADMIN_SYSTEM:READ'],
									children:[
										ElementUtil.makeIcon('vaadin:download', ' Download')
									],
									listeners: {
										click: function() {
											actionDownloadLog(logFileGrid.selectedItems[0]);
										}
									}
								}			
							]
						});
						
						var logFileGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',			
							slot: 'primary',
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true
							},			
							children: [				
								{						
									path: 'filename',
									header: 'File name',
									width: '12em',
									'flex-grow': '1'
								},
								{						
									path: 'lastModifiedDts',
									header: 'Level',
									'text-align': 'center',
									width: '7em',
									renderer: function(root, column, rowData) {
										var date = TimeUtil.parseDate(rowData.item.lastModifiedDts);						
										root.innerHTML = TimeUtil.formatDateStandard(date);
									}
								},
								{
									path: 'fileSize',
									header: 'File Size',
									'text-align': 'center',
									width: '9em'										
								}
							],
							listeners: {
								'active-item-changed': function(event) {
									const item = event.detail.value;
									logFileGrid.selectedItems = item ? [item] : [];
									if (logFileGrid.selectedItems.length > 0) {						
										ElementUtil.query(logToolbar, 'download').disabled = false;
									} else {
										ElementUtil.query(logToolbar, 'download').disabled = true;
									}	
								}
							}
						});						
						
						var flexLayoutLogs = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								logToolbar,
								logFileGrid
							]
						});	
						logWin.addToContentElement(flexLayoutLogs);
						
						var actionRefreshLogs = function() {
							var loadMask = logFileGrid.showLoading();
							Service.getNodeService().getLogFiles(logGrid.nodeId).then(function(data){
								loadMask.remove();
								logFileGrid.items = data;
							});
						};
						actionRefreshLogs();
						
						var actionDownloadLog = function(record) {
							Service.getNodeService().downloadLog(logGrid.nodeId, record.filename);
						};
					}
				}
			});	
			
		};
		
	}
	
};
customElements.define('dl-logs-grid', LogGrid);

